import React, { useState, useEffect } from "react";
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonAvatar,
  IonLabel,
  IonSearchbar,
  IonIcon,
} from "@ionic/react";
import { mailOutline, checkmarkCircle } from "ionicons/icons";
import axios from "axios";
import { SERVER_URL } from "../../api/client";
import { loonlogAvatarSvg } from "../avatar/Avatar2";

const InviteFriendsModal = ({ isOpen, onDismiss, tag }) => {
  const [friends, setFriends] = useState([]);
  const [invitedIds, setInvitedIds] = useState([]); // Track who was invited in this session
  const [searchTerm, setSearchTerm] = useState("");
  // FIX: Reset invitedIds and search term whenever the modal is closed
  useEffect(() => {
    if (!isOpen) {
      setInvitedIds([]);
      setSearchTerm("");
    }
  }, [isOpen]);
  useEffect(() => {
    if (isOpen) {
      const fetchFriends = async () => {
        const res = await axios.get(`${SERVER_URL}/profile`, {
          withCredentials: true,
        });
        setFriends(res.data);
      };
      fetchFriends();
    }
  }, [isOpen]);

  const handleInvite = async (friendId) => {
    try {
      await axios.post(
        `${SERVER_URL}/hashtag/invite-community`,
        { friendId, tag: tag },
        { withCredentials: true },
      );
      setInvitedIds([...invitedIds, friendId]); // Update UI to show "Sent"
    } catch (err) {
      console.error("Invite failed", err);
    }
  };

  const filteredFriends = friends.filter((f) =>
    f.username.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onDismiss}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Invite Members </IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onDismiss}>Close</IonButton>
          </IonButtons>
        </IonToolbar>
        <IonSearchbar
          value={searchTerm}
          onIonInput={(e) => setSearchTerm(e.detail.value)}
        />
      </IonHeader>
      <IonContent>
        <IonList>
          {filteredFriends.map((friend) => (
            <IonItem key={friend._id}>
              <IonAvatar slot="start">
                <img
                  src={
                    friend.avatar ||
                    loonlogAvatarSvg(friend.username, friend.province)
                  }
                  alt="profile"
                />
              </IonAvatar>
              <IonLabel style={{ marginLeft: "12px" }}>
                <h2>
                  {friend.fname} {friend.lname}
                </h2>
                <p>@{friend.username}</p>
              </IonLabel>
              <IonButton
                slot="end"
                fill="clear"
                disabled={invitedIds.includes(friend._id)}
                onClick={() => handleInvite(friend._id)}
              >
                <IonIcon
                  icon={
                    invitedIds.includes(friend._id)
                      ? checkmarkCircle
                      : mailOutline
                  }
                  color={
                    invitedIds.includes(friend._id) ? "success" : "primary"
                  }
                />
              </IonButton>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonModal>
  );
};

export default InviteFriendsModal;
